import { datadogRum } from "@datadog/browser-rum";
import { onAuthStateChanged } from "firebase/auth";
import { firebaseAuth } from "../../../api/firebase/firestoreService";
import { LocalStorageKeys } from "../../../enums/localStorageKeys";
import { setItemInLocalStorage } from "../../../utils/localStorageHelper";
import { AppDispatch } from "../../store/store";
import {
  checkingLoggedInUser,
  loginSuccess,
  resetAllStates,
} from "../auth-slice";

export const getCurrentUser = () => async (dispatch: AppDispatch) => {
  dispatch(checkingLoggedInUser());
  onAuthStateChanged(firebaseAuth, (user) => {
    if (user) {
      const userDetails = {
        email: user.email,
        id: user.uid,
      };

      datadogRum.setUser({
        id: userDetails.id ?? "",
        email: userDetails.email ?? "",
      });

      dispatch(loginSuccess(userDetails));
      setItemInLocalStorage(LocalStorageKeys.USER_ID, userDetails.id);
    } else {
      datadogRum.setUser({});
      dispatch(resetAllStates());
    }
  });
};
